// Padrão visual MPires — tokens base. Diretório NOVO (components/mpires/)
// que não substitui nada existente. Serve como referência central para a
// página /admin/padrao-visual e para novos componentes criados daqui pra
// frente. Nenhuma tela existente consome estes tokens neste lote.
export const colors = {
  marinho: "#003E62",   // estrutura
  primaria: "#008AB0",  // ação e link
  neutro: {
    100: "#F3F6F9",
    300: "#D5DEE5",
    600: "#64748B",
  },
  vermelho: "#C62828",  // estado crítico
  ambar: "#E29700",     // estado atenção
  verde: "#2E7D32",     // estado ok
  branco: "#FFFFFF",
};

export const typography = {
  familia: "Inter, system-ui, -apple-system, sans-serif",
  escala: { xs: 12, sm: 14, md: 16, lg: 20, xl: 24, display: 28 },
  pesos: { regular: 400, medium: 500, semibold: 600 },
};

export const space = { 4: 4, 8: 8, 12: 12, 16: 16, 24: 24, 32: 32 };

export const radii = { botao: 8, campo: 8, card: 12, chip: 999 };
